import { useEffect, useRef, useState } from "react";
import { useIntl } from "react-intl";
import {
  FaApple,
  FaBolt,
  FaBus,
  FaCarSide,
  FaGooglePlay,
  FaHandshake,
  FaLocationDot,
  FaMapLocationDot,
  FaMapPin,
  FaMotorcycle,
  FaRobot,
  FaShieldHalved,
  FaStar,
  FaStore,
  FaTrophy,
  FaUsers,
  FaUtensils,
} from "react-icons/fa6";
import "../AllMetuaaEat/metuaaEat.css";
import "../style01.css";
import "../style02.css";
import "./metuaa.css";
import Header from "../../../components/header";
import Footer from "../../../components/footer";
import heroImage from "../../../assets/images/metuaa_green.png";
import mapperImage from "../../../assets/images/image-mapper.png";
import eatImage from "../../../assets/images/metuaa-eat.png";
import travelImage from "../../../assets/images/travel hub 6.png";
import driverImage from "../../../assets/images/all-slider/driver-slide-cameroon.png";
import enterpriseImage from "../../../assets/images/all-slider/image-entreprise.png";
import mplusImage from "../../../assets/images/New-2025-Kia-Carnival-6.avif";
import phoneImage from "../../../assets/images/phone0.png";
import offer_1 from "../../../assets/images/offer_1.png";
import offer_2 from "../../../assets/images/offer_2.png";

const heroSlides = [
  {
    webp: heroImage,
    src: heroImage,
    alt: "Metua'a, l'écosystème de mobilité et de services au Cameroun",
    title1: "Metua'a,",
    title2: "tout un écosystème à portée de main",
    description:
      "Transport, livraison, restauration, covoiturage interurbain, cartographie participative : Metua'a connecte les chauffeurs, les passagers, les entreprises et les communautés en un seul geste.",
    ctaHref: "/signup-passenger",
    ctaLabel: "Commencer maintenant",
  },
];

const heroTransitionTypes = ["fade", "slide-left", "slide-right", "square"];

const services = [
  {
    key: "mapper",
    image: mapperImage,
    icon: FaMapPin,
    title: "Metua'a Mappers",
    text: "Numérisez votre quartier, validez des lieux et gagnez de l'argent en aidant la communauté à mieux se déplacer.",
    href: "/metuaa-mapper",
  },
  {
    key: "eat",
    image: eatImage,
    icon: FaUtensils,
    title: "Metua'a Eats",
    text: "Commandez vos plats préférés et faites-vous livrer à domicile ou au bureau, en toute fraîcheur.",
    href: "/metuaa-eat",
  },
  {
    key: "travel",
    image: travelImage,
    icon: FaBus,
    title: "Metua'a Travel Hub",
    text: "Covoiturage et voyages interurbains : réservez votre place auprès des compagnies de transport.",
    href: "/metuaa-travel-hub",
  },
  {
    key: "driver",
    image: driverImage,
    icon: FaMotorcycle,
    title: "Conduire avec Metua'a",
    text: "Soyez votre propre patron. Gagnez de l'argent en conduisant quand vous voulez.",
    href: "/all-driver",
  },
  {
    key: "enterprise",
    image: enterpriseImage,
    icon: FaHandshake,
    title: "Metua'a Entreprise",
    text: "Simplifiez les déplacements de vos collaborateurs et gérez vos opérations avec des outils sécurisés.",
    href: "/all-enterprise",
  },
  {
    key: "mplus",
    image: mplusImage,
    icon: FaCarSide,
    title: "Programme M+",
    text: "Acquérez votre propre véhicule grâce au programme M+ et maximisez vos revenus quotidiens.",
    href: "/mplus-program",
  },
];

const howItWorksSteps = [
  {
    key: "choose",
    icon: FaStore,
    title: "Choisissez votre service",
    text: "Course, repas, trajet interurbain ou mission de cartographie : sélectionnez le service Metua'a dont vous avez besoin.",
  },
  {
    key: "request",
    icon: FaLocationDot,
    title: "Faites votre demande",
    text: "Indiquez votre position et votre destination. Nous vous connectons au bon partenaire, en temps réel.",
  },
  {
    key: "ride",
    icon: FaBolt,
    title: "Profitez de l'écosystème",
    text: "Suivez votre course ou votre livraison, payez en toute sécurité et profitez des avantages Metua'a.",
  },
];

const featureCards = [
  {
    key: "africa",
    icon: FaUsers,
    title: "Une solution 100% africaine",
    text: "Conçue par Africa Systems pour le contexte camerounais : motos, voitures, trucks et services adaptés à vos réalités.",
  },
  {
    key: "secure",
    icon: FaShieldHalved,
    title: "Paiements sécurisés",
    text: "Wallet intégré, paiements mobile money et transactions protégées : votre argent est toujours en sécurité.",
  },
  {
    key: "allinone",
    icon: FaRobot,
    title: "Un seul geste, tous vos services",
    text: "Transport, livraison, restauration et covoiturage réunis dans un seul écosystème connecté.",
  },
  {
    key: "rewards",
    icon: FaTrophy,
    title: "Récompenses Metua'a",
    text: "Programme de fidélité et bonus : chaque course et chaque mission vous rapporte des avantages exclusifs.",
  },
];

const metuaaFilters = [
  { id: "all", label: "home.categories.all", icon: FaStar },
  { id: "transport", label: "home.categories.transport", icon: FaCarSide },
  { id: "delivery", label: "home.categories.delivery", icon: FaBolt },
  { id: "eat", label: "home.categories.eat", icon: FaUtensils },
  { id: "travel", label: "home.categories.travel", icon: FaBus },
  { id: "mapper", label: "home.categories.mapper", icon: FaMapPin },
  { id: "enterprise", label: "home.categories.enterprise", icon: FaHandshake },
];

function ChevronLeftIcon() {
  return (
    <svg width="24" height="24" viewBox="0 0 32 32" style={{ fill: "currentColor" }} aria-hidden="true" focusable="false">
      <path d="m12.843 25.836 1.585-1.608L7.32 17.12H29v-2.256H7.321l7.107-7.13-1.585-1.585L3 15.993l9.843 9.843z" />
    </svg>
  );
}

function ChevronRightIcon() {
  return (
    <svg width="24" height="24" viewBox="0 0 32 32" style={{ fill: "currentColor" }} aria-hidden="true" focusable="false">
      <path d="m19.157 6.15-1.584 1.608 7.106 7.107H3v2.256h21.679l-7.106 7.13 1.584 1.585L29 15.993 19.157 6.15z" />
    </svg>
  );
}

const IconArrowRight = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" style={{ fill: "currentColor" }} aria-hidden="true" focusable="false">
    <path d="M9.652 2.65 8.426 3.876l3.258 3.258H1v1.728h10.684L8.426 12.12l1.226 1.226L15 7.998 9.652 2.65z" />
  </svg>
);

export default function AllMetuaa() {
  const intl = useIntl();
  const t = (id) => intl.formatMessage({ id });
  const [heroIndex, setHeroIndex] = useState(0);
  const [heroPrevIndex, setHeroPrevIndex] = useState(0);
  const [heroTransition, setHeroTransition] = useState("fade");
  const [isHeroPaused, setIsHeroPaused] = useState(false);
  const [activeMetuaaFilter, setActiveMetuaaFilter] = useState("all");
  const heroTimerRef = useRef(null);

  const goToHeroSlide = (updater) => {
    const type = heroTransitionTypes[Math.floor(Math.random() * heroTransitionTypes.length)];
    setHeroTransition(type);
    setHeroIndex(updater);
  };

  useEffect(() => {
    if (isHeroPaused || heroSlides.length <= 1) return;
    heroTimerRef.current = setInterval(() => {
      goToHeroSlide((prev) => (prev + 1) % heroSlides.length);
    }, 5000);
    return () => clearInterval(heroTimerRef.current);
  }, [isHeroPaused]);

  useEffect(() => {
    if (heroPrevIndex === heroIndex) return;
    const id = setTimeout(() => setHeroPrevIndex(heroIndex), 900);
    return () => clearTimeout(id);
  }, [heroIndex, heroPrevIndex]);

  const hasMultipleSlides = heroSlides.length > 1;

  return (
    <div id="__next">
      <div className="sc-19804fb5-0 fKeZVt">
        <span data-testid="core-ui-theme-provider" className="sc-dGCmGc kFXgow">
          <span data-testid="core-ui-theme-provider" className="sc-dGCmGc cukWQg">
            <Header />

            <main className="metuaa-page">
              {/* ══════════════════ HERO SLIDE ══════════════════ */}
              <section
                data-testid="metuaa-hero-slider"
                className="eats-slider"
                onMouseEnter={() => setIsHeroPaused(true)}
                onMouseLeave={() => setIsHeroPaused(false)}
              >
                <picture className="eats-slider__layer">
                  <source type="image/webp" srcSet={heroSlides[heroPrevIndex].webp} />
                  <img src={heroSlides[heroPrevIndex].src} alt={heroSlides[heroPrevIndex].alt} />
                </picture>

                {heroIndex !== heroPrevIndex && (
                  <picture key={heroIndex} className={`eats-slider__layer eats-slider__anim hero-anim-${heroTransition}`}>
                    <source type="image/webp" srcSet={heroSlides[heroIndex]?.webp} />
                    <img src={heroSlides[heroIndex]?.src} alt={heroSlides[heroIndex]?.alt} />
                  </picture>
                )}

                <div className="eats-slider__overlay" aria-hidden="true" />

                <div className="eats-slider__content">
                  <div key={heroIndex} className={`hero-slide-anim hero-anim-${heroTransition}`}>
                    <h1 className="eats-slider__title">
                      {heroSlides[heroIndex]?.title1} <span>{heroSlides[heroIndex]?.title2}</span>
                    </h1>
                    <p className="eats-slider__desc">{heroSlides[heroIndex]?.description}</p>
                    <div className="eats-slider__search">
                      <span className="eats-slider__search-icon">
                        <FaLocationDot />
                      </span>
                      <input type="text" placeholder={t("home.search.placeholder")} />
                      <button type="button">{t("home.search.button")}</button>
                    </div>
                    <div className="hero-btn-group">
                      <a href={heroSlides[heroIndex]?.ctaHref} className="eats-slider__cta">
                        {heroSlides[heroIndex]?.ctaLabel}
                      </a>
                    </div>
                  </div>
                </div>

                {hasMultipleSlides && (
                  <>
                    <button
                      type="button"
                      className="eats-slider__arrow eats-slider__arrow--prev"
                      aria-label="Diapositive précédente"
                      onClick={() => goToHeroSlide((prev) => (prev - 1 + heroSlides.length) % heroSlides.length)}
                    >
                      <ChevronLeftIcon />
                    </button>
                    <button
                      type="button"
                      className="eats-slider__arrow eats-slider__arrow--next"
                      aria-label="Diapositive suivante"
                      onClick={() => goToHeroSlide((prev) => (prev + 1) % heroSlides.length)}
                    >
                      <ChevronRightIcon />
                    </button>
                    <div className="eats-slider__dots">
                      {heroSlides.map((_, i) => (
                        <button
                          key={i}
                          type="button"
                          aria-label={`Diapositive ${i + 1}`}
                          className={`eats-slider__dot${i === heroIndex ? " is-active" : ""}`}
                          onClick={() => goToHeroSlide(() => i)}
                        />
                      ))}
                    </div>
                  </>
                )}
              </section>

              {/* ══════════════════ FILTRES ══════════════════ */}
              <section className="food-filters-section" aria-label="Filtres de services">
                <div className="filters-scroll">
                  {metuaaFilters.map(({ id, label, icon: Icon }) => (
                    <button
                      key={id}
                      type="button"
                      className={`filter-chip${activeMetuaaFilter === id ? " active" : ""}`}
                      aria-pressed={activeMetuaaFilter === id}
                      onClick={() => setActiveMetuaaFilter(id)}
                    >
                      <Icon aria-hidden="true" />
                      {t(label)}
                    </button>
                  ))}
                </div>
              </section>

              {/* ══════════════════ SERVICES ══════════════════ */}
              <section className="metuaa-services-section">
                <div className="page-shell">
                  <h2 className="metuaa-services-title">
                    Un écosystème, <mark>tous vos services</mark>
                  </h2>
                  <p className="metuaa-services-subtitle">
                    Découvrez les services Metua'a et choisissez celui qui vous ressemble.
                  </p>
                  <div className="metuaa-services-grid">
                    {services.map((service) => (
                      <a key={service.key} href={service.href} className="metuaa-service-card">
                        <div className="metuaa-service-image">
                          <img src={service.image} alt={service.title} loading="lazy" decoding="async" />
                        </div>
                        <div className="metuaa-service-body">
                          <span className="metuaa-service-icon" aria-hidden="true">
                            <service.icon />
                          </span>
                          <h3>{service.title}</h3>
                          <p>{service.text}</p>
                          <span className="metuaa-service-link">
                            Découvrir <FaMapLocationDot aria-hidden="true" />
                          </span>
                        </div>
                      </a>
                    ))}
                  </div>
                </div>
              </section>

              {/* ══════════════════ HOW IT WORKS ══════════════════ */}
              <section className="how-it-works-section" data-qa="how-it-works-section">
                <div className="how-it-works-content">
                  <h3 className="how-it-works-eyebrow">Comment ça marche ?</h3>
                  <h2 className="how-it-works-title">Simple et rapide !</h2>
                  <div className="how-it-works-grid">
                    {howItWorksSteps.map((step) => (
                      <article key={step.key} className="how-it-works-card">
                        <step.icon aria-hidden="true" className="how-it-works-icon" />
                        <h5 className="how-it-works-card-title">{step.title}</h5>
                        <p className="how-it-works-card-text">{step.text}</p>
                      </article>
                    ))}
                  </div>
                </div>
              </section>

              {/* ══════════════════ FEATURE CARDS ══════════════════ */}
              <section className="feature-cards-section">
                <div className="page-shell">
                  <h2 className="feature-cards-title">Pourquoi choisir Metua'a ?</h2>
                  <div className="feature-cards-grid">
                    {featureCards.map((card) => (
                      <article key={card.key} className="feature-card">
                        <card.icon aria-hidden="true" className="feature-card-icon" />
                        <h3>{card.title}</h3>
                        <p>{card.text}</p>
                      </article>
                    ))}
                  </div>
                </div>
              </section>

              {/* ══════════════════ OFFERS ══════════════════ */}
              <section
                className="all-page-section sc-cd975d71-0 fJfYVy sc-4d039203-0 iaLMvL"
                data-tracking-label="Homepage > Brand Redesign Jun 2025 > Metua'a Up"
                data-tracking-action="view"
                data-tracking-category="TextImageModule"
              >
                <div className="sc-eNSrOW kusvag">
                  <div
                    className="sc-satoz iYojpr"
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      flexWrap: "wrap",
                      gap: "24px",
                      width: "100%",
                    }}
                  >
                    {/* Colonne 1 : Card Package Famille */}
                    <div className="offer-card-col">
                      <div className="cardOffer" style={{ backgroundImage: `url(${offer_1})` }}>
                        <div className="cardOffer-overlay">
                          <p className="cardOffer-label">{t("home.offers.family.label")}</p>
                          <h3 className="cardOffer-title">{t("home.offers.family.title")}</h3>
                          <div className="cardOffer-code">
                            <span className="cardOffer-code-label">{t("home.offers.codeLabel")}</span>
                            <span className="cardOffer-code-value">{t("home.offers.codeValue")}</span>
                          </div>
                          <button className="cardOffer-button">
                            {t("home.offers.discover")}
                            <IconArrowRight />
                          </button>
                        </div>
                      </div>
                    </div>

                    {/* Colonne 2 : Card Package Entreprise */}
                    <div className="offer-card-col">
                      <div className="cardOffer" style={{ backgroundImage: `url(${offer_2})` }}>
                        <div className="cardOffer-overlay">
                          <p className="cardOffer-label">{t("home.offers.business.label")}</p>
                          <h3 className="cardOffer-title">{t("home.offers.business.title")}</h3>
                          <div className="cardOffer-code">
                            <span className="cardOffer-code-label">{t("home.offers.codeLabel")}</span>
                            <span className="cardOffer-code-value">{t("home.offers.codeValue")}</span>
                          </div>
                          <button type="button" className="cardOffer-button">
                            <span>{t("home.offers.discover")}</span>
                            <IconArrowRight />
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </section>

              {/* ══════════════════ DOWNLOAD APP ══════════════════ */}
              <section className="download-app-section" data-qa="download-app-section">
                <div className="page-shell">
                  <div className="download-app-layout">
                    <div className="download-app-info">
                      <h3 className="download-app-title">Téléchargez l'application</h3>
                      <p className="download-app-subtitle">Tous les services Metua'a, où que vous soyez !</p>
                      <div className="download-app-stores">
                        <a className="store-badge" href="#" aria-label="Accéder à iOS App Store" data-qa="download-app-section-ios-link">
                          <FaApple aria-hidden="true" />
                          <span>App Store</span>
                        </a>
                        <a className="store-badge" href="#" aria-label="Accéder à Google Play Store" data-qa="download-app-section-android-link">
                          <FaGooglePlay aria-hidden="true" />
                          <span>Google Play</span>
                        </a>
                      </div>
                    </div>
                    <div className="download-app-visual">
                      <img src={phoneImage} alt="Aperçu de l'application Metua'a" loading="lazy" decoding="async" />
                    </div>
                  </div>
                </div>
              </section>
            </main>

            <Footer />
          </span>
        </span>
      </div>
    </div>
  );
}
